import React, { Component } from 'react';
import Home from '../Home/Home';
import Menu from '../Menu/Menu';
import Video from '../../Components/videoAll/videoAll';
import Traiteur from '../Traiteur/Traiteur';
import { Switch, Route } from 'react-router-dom';

class allClass extends Component {
    render() {
        return (
            <div>
                <Switch>
                <Route path="/traiteur" component={() => <Traiteur /> } />
                <Route path="/menu" component={() => <Menu />} />
                <Route path="/video" component={() => <Video />} />
                <Route path="/" component={() => <Home />} />
                </Switch>
            </div>
        );
    }
}

export default allClass;

